// extracted by mini-css-extract-plugin
export var cardHeader = "_hj-0";
export var reorderHandle = "_hj-3";
export var titleArea = "_hj-1";
export var titleAreaWithHandle = "_hj-2";